import { Chip, Stack, Tooltip, Typography } from "@mui/material";

type StatGroupProps = {
  title: string;
  data?: Record<string, number>;
  color: string;
};
export const StatGroup = ({ title, data, color }: StatGroupProps) => {
  if (!data) return null;
  return (
    <Stack spacing={1} alignItems="center" textAlign="center">
      <Typography variant="subtitle1" fontWeight={600}>
        {title}
      </Typography>
      <Stack direction="row" flexWrap="wrap" gap={1}>
        {Object.entries(data).map(([k, v]) => (
          <Tooltip key={k} title={`${v} ${k}`}>
            <Chip label={`${k} – ${v}`} sx={{ bgcolor: color + "22" }} />
          </Tooltip>
        ))}
      </Stack>
    </Stack>
  );
};
